/**
 * @fileoverview A function that formats the given date (ISO 8601) to the "mm dd, 'yy" string
 *
 * @example
 * formatDate('2024-01-01')
 */

import { DateTime } from 'luxon'
import { formatOutput } from './formatOutput'

/**
 * @function formatDate
 * @description Formats the given date (ISO 8601) to the "mm dd, 'yy" string
 * @param {string} date - The date to format.
 * @returns {JSX.Element} - The formatted date.
 */
export function formatDate(date: string): JSX.Element {
    if (!date) return formatOutput(undefined)

    const d = DateTime.fromISO(date)
    const formattedDate = d.toFormat('MMM dd, yyyy')

    return <span>{formattedDate}</span>
}

/**
 * @function formatDateToRelative
 * @description Formats the given date (ISO 8601) to the relative date string
 * @param {string} date - The date to format.
 * @returns {JSX.Element} - The formatted date.
 */
export function formatDateToRelative(date: string): JSX.Element {
    if (!date) return formatOutput(undefined)

    const d = DateTime.fromISO(date)
    const formattedDate = d.toRelative()

    return <span>{formattedDate}</span>
}
